import React from 'react';
import { useTheme } from '@mui/material';

type DonutCenterDisplayProps = {
  innerRadius: number;
  value: string;
  label?: string;
};

export const DonutCenterDisplay = ({ innerRadius, value, label = 'TOTAL' }: DonutCenterDisplayProps) => {
  const theme = useTheme();

  const valueFontSize = Math.min(50, innerRadius / 2);
  const labelFontSize = Math.min(40, innerRadius / 3.5);
  const gap = Math.min(45, innerRadius / 4);

  return (
    <g role="img" aria-label={`${label}: ${value}`}>
      <text
        x={0}
        y={-gap}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={labelFontSize}
        fill={theme.palette.colors.neutrals[500]}
        aria-hidden="true"
        style={{ userSelect: 'none' }}>
        {label}
      </text>
      <text
        x={0}
        y={gap}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize={valueFontSize}
        fontWeight={600}
        fill={theme.palette.colors.neutrals[800]}
        aria-hidden="true"
        style={{ userSelect: 'none' }}>
        {value}
      </text>
    </g>
  );
};
